import axios from "../index"

// 接口基础路径
const rootApi = '/api_v2/deviceInfo'

/** 获取下拉选项 */
export const getDeviceInfoOptions = (params) => {
  return axios.get(`${rootApi}/getOptions`, {params})
}
